//import libraries
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';

//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';


//import language
import { ServicingListLang, ServicingCreateLang, ServicingViewLang, ServicingUserLang, SettingsListLangForm, SettingsEditLangForm, SettingsSettingsLang, ServicingCalendarLang, ServicingGeneralLang, ServicingMaintenancePlanningLang, ServicingViewGeneralLang, ServicingMaintenanceLang, ServicingOrdinaryLang, ServicingExOrdinaryLang, ServicingDocumentsLang } from '../languages/Servicing.Lang';

import { MeasurementListLang, MeasurementCreateListLang, MeasurementViewLang, MeasurementOrdinaryLang } from '../languages/Measurement.Lang';


import { ProblemSolvingListLang } from '../languages/Problem_Solving.Lang';




//import services
import { GeneralService } from '../services/general.service';

//import classes
// import {
//     SettingsFormMangIn, SettingsFormMangOut
//   } from '../classes/settings.model';

import {
    ServicingList, ServicingGeneralGet, ServicingGeneralPostIn, ServicingGeneralPostOut } from '../classes/servicing.model';


@Injectable()


export class ProblemSolvingService implements Resolve<Observable<any>>{

    constructor(
        private http: HttpClient,
        private generalService: GeneralService,
    ) { }

    resolve() {
        return this.MeasurementGetData();
    }

    MeasurementGetData(): Observable<ServicingList> {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.create;
        return this.http.get<any>(url);

    }
    
    listLang(details: any) {

        if (!details) return;

        // console.log('test');

        let instance = new ProblemSolvingListLang(details.data.language);
        return instance.lang();

    }

    GeneralGetLangData(details: any) {

        if (!details) return;

        let instance = new MeasurementListLang(details.data.language);
        return instance.lang();

    }

    measurementviewLang(details: any) {

        if (!details) return;

        let instance = new MeasurementViewLang(details.data.language);
        return instance.lang();

    }

    CreatelistLang(details: any) {

        if (!details) return;

        // console.log('test');

        let instance = new MeasurementCreateListLang(details.data.language);
        return instance.lang();

    }

    ServicingMaintenanceLang(details: any) {

        if (!details) return;
        let instance = new ServicingMaintenanceLang(details.data.language);
        return instance.lang();
    }

    
    GeneralPostData(data: ServicingGeneralPostIn) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.profileGeneralPost;
        return this.http.post<ServicingGeneralPostOut>(url, data);
    }

    generalLang(details: any) {

        if (!details) return;

        let instance = new ServicingGeneralLang(details.data.language);
        return instance.lang();

    }


    createLang(details: any) {

        if (!details) return;

        let instance = new MeasurementListLang(details.data.language);
        return instance.lang();

    }

    // treatment_unlock(pid: any, id: any) {
        
    //     let data = { 'pid': pid,'id': id };

    //     let url = AppSettings.API_ENDPOINT + AppBackRoutes.treatment_unlock;
    //     return this.http.post<any>(url, data);
    // }

    treatment_unlock(pid: any, id: any) {
        let data = { 'pid': pid,'id': id };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.treatmentUnlock;
        return this.http.post<any>(url, data);
    }



    update(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.problemsolvingCreate;
        return this.http.post<any>(url, data);
    }


    view_problem_pdfexport(id: any) {
        let data = { 'id': id }
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.view_problem_pdfexport;
        return this.http.post<any>(url, data, {  responseType: 'blob' as 'json' });
    }

    update_sendstake(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.send_customer_attchs_changed;
        return this.http.post<any>(url, data);
    }

    update_treatment(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.update_treatment;
        return this.http.post<any>(url, data);
    }


    update_cause(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.update_cause;
        return this.http.post<any>(url, data);
    }

    update_corrective(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.update_corrective;
        return this.http.post<any>(url, data);
    }

    update_check(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.update_check;
        return this.http.post<any>(url, data);
    }

    updateMeasurement(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.updateMeasurement;
        return this.http.post<any>(url, data);
    }

    sorting(data: any, table: any) {

        let data1 = { 'id': data, 'table': { 'table_name': 'kaizen_problem_solving', 'id': 'id', 'order': 'sort1' } };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.problemSolvingSorting;
        // console.log(url);
        return this.http.post<any>(url, data1);
    }


    update_extraordinary(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.exordinary_servicing;
        return this.http.post<any>(url, data);
    }

    update_ordinary(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.ordinary_servicing;
        return this.http.post<any>(url, data);
    }

    update_mplans(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.mordinary_servicing;
        return this.http.post<any>(url, data);
    }

    update_maintenance(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.cpupdate_maintenance;
        return this.http.post<any>(url, data);
    }
    
    update_documents(data: any) {
        // console.log(data); return false;
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.update_documents;
        return this.http.post<any>(url, data);
    }


    edit(id: any) {
        let data = {'id' : id,'action':'add_prob_solv'};
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.problemsolvingEdit;
        return this.http.post<any>(url, data);
    }

    edit_ordinary(id: any, sid: any, pid: any) {

        let data = { 'data_action': 'modify','action': 'intervention_update', 'intervention_id': id, 'service_id': sid, 'plan_id': pid };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.edit_mordinary;
        return this.http.post<any>(url, data);
    }


    edit_extraordinary(id: any) {
        let data = {'action' : 'edit_extraordinary', 'id' : id};
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.edit_extraordinary;
        return this.http.post<any>(url, data);
    }

    
    editMeasurementformdata(id: any) {
        let data = {'action' : 'maintenance_form', 'plan_id' : id};
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.editMeasurementformdata;
        return this.http.post<any>(url, data);
    }


    edit_documents(id: any) {
        let data = { 'data_action': 'modify','action': 'edit_documents','docId': id };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.edit_documents;
        return this.http.post<any>(url, data);
    }

    

    duplicate(id: any) {

        let data = [id];
        return this.multiDuplicate(data);
        
    }

    multiDelete(ids: any) {
        let data = { 'cid': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.psMultiDelete;
        return this.http.post<any>(url, data);
    }

    cmultiDelete(ids: any) {
        let data = { 'id': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.calibrationMultiDelete;
        return this.http.post<any>(url, data);
    }
    
    multiDelete1(ids: any) {
        let data = { 'id': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingMainMultiDelete;
        return this.http.post<any>(url, data);
    }

    multiDelete_maintenance(ids: any) {
        let data = { 'plan_ids': ids, 'action' : 'plans_table_delete' };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.cpmultiDeleteMaintenance;
        return this.http.post<any>(url, data);
    }


    
        
    delete_mextraordinary(ids: any) {
        let data = { 'id': ids };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.delete_mextraordinary;
        return this.http.post<any>(url, data);
    }
    
        
        
    delete_msdocuments(ids: any) {
        let data = { 'id': ids,'action' : 'multidelete_documents' };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.delete_msdocuments;
        return this.http.post<any>(url, data);
     }


    multiDuplicate(ids: any) {

        let data = {'id' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.psMultiDuplicate;
        return this.http.post<any>(url, data);

    }
    multiOrdDuplicate(ids: any) {

        let data = {'id' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.mvmultiOrdDuplicate;
        return this.http.post<any>(url, data);

    }
    
    
    multiExtraDuplicate(ids: any) {

        let data = {'id' : ids};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.multiExtraDuplicate;
        return this.http.post<any>(url, data);

    }

    multiDuplicate_maintenance(ids: any) {

        let data = {'plan_ids' : ids, 'action' : 'plans_table_copy' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.cpmultiDuplicateMaintenance;
        return this.http.post<any>(url, data);

    }

    doc_multiDuplicate(ids: any) {

        let data = {'id' : ids, 'action' : 'multiduplicate_documents'};

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.duplicate_msdocuments;
        return this.http.post<any>(url, data);

    }

    

    getList(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.problemsolvingList;
        return this.http.get<any>(url);

    }

    getCalibrationList(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.cmeasurementList;
        return this.http.get<any>(url);

    }

    create(){

        // let url = AppSettings.API_ENDPOINT + AppBackRoutes.create;
        // return this.http.post<any>(url);

        let data = { 'action': '' };
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.create;
        return this.http.post<any>(url, data);



    }

    getProblemsList(){
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getProblemsList;
        return this.http.get<any>(url);
    }


    getMaintenanceformdata(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.getMeasurementformdata;
        return this.http.get<any>(url);

    }


    getMaintenanceList() {
        let data = { 'submit': '' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.calibrationPlans;
        return this.http.post<any>(url,data);
    }
    

    exordinaryData(id: any){

        let data = { 'eid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.exordinaryData;
        return this.http.post<any>(url, data);

    }


    ordinaryData(id: any){

        let data = { 'oid': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.mvordinaryData;
        return this.http.post<any>(url, data);

    }


    documentsData(){

        let data = { 'action': 'add_documents' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.documentsData;
        return this.http.post<any>(url, data);

    }


    generalList(id: any){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.psingle_view + '/' + id;
        return this.http.get<any>(url);

    }

    GeneralGetServData(resp: ServicingGeneralGet) {
        console.log(resp);
        return (resp) ? resp.data.single_data : null;
    }


    //     resolve() {
    //     return this.FetchDetails();
    // }

    // FetchDetails(): Observable<any> {

    //     let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsData;
    //     return this.http.get<any>(url);

    // }

    getlistLangForm(details: any) {

        if (!details) return;

        let instance = new SettingsListLangForm(details.language);
        return instance.lang();

    }

    getEditLangForm(details: any) {

        if (!details) return;

        let instance = new SettingsEditLangForm(details.language);
        return instance.lang();

    }

    getSettingsLang(details: any) {

        if (!details) return;

        let instance = new SettingsSettingsLang(details.language);
        return instance.lang();

    }

    // FormMangServCall(input : SettingsFormMangIn) {
    //     let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsFormMang;
    //     return this.http.post<SettingsFormMangOut>(url, input);
    // }

    FormMangUpdate(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsFormMang;
        return this.http.post<any>(url, data);
    }

    settingsUpdate(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.settingsSettings;
        return this.http.post<any>(url, data);
    }
    
    delete(id: any) {

        let data = { 'id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.problemsolvingDelete;
        return this.http.post<any>(url, data);

    }

    viewDelete(id: any) {

        let data = { 'id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.problemsolvingViewDelete;
        return this.http.post<any>(url, data);

    }

    sendMail(id: any) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.sendMail + '/' + id;
        return this.http.get<any>(url);

    }

    pdfexport(id: any) {

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.pdfexport + '/' + id;
        return this.http.get<any>(url);

    }


    delete_extraordinary(id: any) {

        let data = { 'id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteExtraordinary;
        return this.http.post<any>(url, data);

    }

    delete_ordinary(id: any) {

        let data = { 'id': id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteOrdinary;
        return this.http.post<any>(url, data);

    }

    deleteMultiOrdinary(id: any) {

        let data = { 'cid': id };

        // console.log(data);

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.mvdeleteMultiOrdinary;
        return this.http.post<any>(url, data);

    }

    
    
    delete_maintenance(id: any) {

        let data = { 'plan_id': id, 'action' : 'plans_delete' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.cpdeleteMaintenance;
        return this.http.post<any>(url, data);

    }

    
    
    delete_sdocuments(id: any) {

        let data = { 'docId': id, 'action' : 'delete_documents' };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.deleteDocuments;
        return this.http.post<any>(url, data);

    }

    updateProfile(profileImage: any){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.problemsolvinguploadExcel;
 
         let headers = new HttpHeaders({
             'Content-Type': 'application/json'
          });
 
         let options = {
             headers: headers
          }
 
         let data = {'profile' : profileImage};
          return this.http.post<any>(url, data, options);
 
    }
    


    updateImport(profileImage: any){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.documentsuploadExcel;
 
         let headers = new HttpHeaders({
             'Content-Type': 'application/json'
          });
 
         let options = {
             headers: headers
          }
 
         let data = {'profile' : profileImage,'action': 'import_documents'};
          return this.http.post<any>(url, data, options);
 
    }
    


    mLangData(details: ServicingList) {
        if (!details) return;

        // console.log('test');

        let instance = new ServicingMaintenancePlanningLang(details.data.language);
        return instance.lang();


        // if (!resp)
        //     return;

        // let lang = {};

        // let gen = resp.data.language.general;
        // // console.log(gen);
        // lang = Object.assign(lang, { general: this.generalService.service_inject(ServicingUserLang.general, gen) });

        // let dash = resp.data.language.service;
        // lang = Object.assign(lang, { user: this.generalService.service_inject(ServicingUserLang.user, dash) });

        // return lang;
    }

    servicingviewLang(details: ServicingList) {
        if (!details) return;

        let instance = new ServicingViewGeneralLang(details.data.language);
        return instance.lang();

    }


    MeasurementOrdinaryLang(details: ServicingList) {
        if (!details) return;

        let instance = new MeasurementOrdinaryLang(details.data.language);
        return instance.lang();

    }

    ServicingExOrdinaryLang(details: ServicingList) {
        if (!details) return;

        let instance = new ServicingExOrdinaryLang(details.data.language);
        return instance.lang();

    }
    

    ServicingDocumentsLang(details: ServicingList) {
        if (!details) return;

        let instance = new ServicingDocumentsLang(details.data.language);
        return instance.lang();

    }

    MaintenanceData(resp: ServicingList) {

        // console.log(resp);

        return (resp) ? resp.data.all_mplans : null;
    }

    calendar(){

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.servicingCalendar;
        return this.http.get<any>(url);

    }

    calendarLang(details: any) {

        if (!details) return;
        let instance = new ServicingCalendarLang(details.language);
        return instance.lang();

    }

    turnoff(sID : any,pid : any,rid : any) {

        let data = { 'sID': sID, 'pid': pid, 'rid': rid };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.measurementTurnoff;
        return this.http.post<any>(url, data);

    }

    active_status(date : any,plan_id_forcd : any,pservice_id : any) {

        let data = { 'start_date': date, 'plan_id_forcd': plan_id_forcd, 'service_id': pservice_id };

        let url = AppSettings.API_ENDPOINT + AppBackRoutes.mvactive_status;
        return this.http.post<any>(url, data);

    }

    Plancodecheck(data: any) {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.check_cpplancode;
        return this.http.post<any>(url, data, { headers: new HttpHeaders({'loader': 'false'}) });
    }


}